/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Stop_CameraInputs */

const vi_mobile_stop_camera = /** @type {(inputs: Mobile_Stop_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dừng quét`)
};

/**

* @param {Mobile_Stop_CameraInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const mobile_stop_camera = /** @type {((inputs?: Mobile_Stop_CameraInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Stop_CameraInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_mobile_stop_camera(inputs)
});